// extracted by mini-css-extract-plugin
export default {"table":"table__PE1Fa","table__cell":"table__cell__E7NfY","actor":"actor__VHdMS","actor__title":"actor__title__JoQxb","loader":"loader__NZyfS"};